import { useEffect, useState } from 'react'
import Form from 'react-bootstrap/Form'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import styles from './customDatePicker.module.css'
export const CustomDatePicker = ({ value, onChange, isFilter = false }) => {
  const [date, setDate] = useState(value || null)

  useEffect(() => {
    if (!value) {
      setDate(null)
      return
    }

    // value should be ISO (YYYY-MM-DD) or full ISO timestamp
    const parsed = new Date(value)

    if (!isNaN(parsed.getTime())) {
      setDate(parsed)
    } else {
      console.warn('Invalid date value passed to DatePicker:', value)
      setDate(null)
    }
  }, [value])

  const handleChange = (newDate) => {
    setDate(newDate)
    onChange?.(newDate)
  }

  return (
    <Form.Group>
      <DatePicker
        selected={date}
        onChange={handleChange}
        className={
          isFilter ? styles.dateInput : `form-control ${styles.fullWidth}`
        }
        placeholderText='Pick a date'
        dateFormat='dd/MM/yyyy'
      />
    </Form.Group>
  )
}
